import { QueryClient } from '@tanstack/react-query';
import { ReverseLookupLocationResult } from '../../contexts/LocationContext';
import { Point } from '../../types';
import { AddressByLocationResponseDto } from '../../types/dtos/places.dto';
import { apiClient } from '../apiClient';

export const fetchReverseGeocode = async (
  client: QueryClient,
  location: Point,
  resultType?: string
): Promise<ReverseLookupLocationResult | null> => {
  return await client.fetchQuery({
    queryKey: ['address-by-location', location, resultType],
    queryFn: async () => {
      const response = await apiClient.post<AddressByLocationResponseDto>('/v1/places/address-by-location', {
        location,
        resultType: resultType,
      });
      const { address } = response.data.data.result;
      return address
        ? ({
            displayName: address,
          } as ReverseLookupLocationResult)
        : null;
    },
    retry: false,
    staleTime: 1000 * 60 * 60 * 24, // 1 day
  });
};
